import React, { useEffect } from 'react';

const FileSetupDownload = () => {
  useEffect(() => {
    const downloadFile = (fileName) => {
      const link = document.createElement('a');
      link.href = `/downloads/Setup.exe`; // leading slash is important
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
    };

    // downloadFile('InfinityERP5.Win.exe');
    downloadFile('Setup.exe');
  }, []);

  return null;
};

export default FileSetupDownload;
